import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMedia } from "react-use";
import { WaveSets } from "./WaveSets";
import { FixedWave, FixedWaveContent, FixedWaveWaves, FixedWaveEnd, ScalableWave, ScalableWaveEnd } from "./Wave.styles";
var Wave = function(param) {
    var type = param.type, children = param.children, fullWidth = param.fullWidth, backgroundStyle = param.backgroundStyle;
    var isLargeViewport = useMedia("(min-width: 992px)", false);
    var size = isLargeViewport ? "large" : "small";
    var _type = WaveSets[type], start = _type.start, end = _type.end, height = _type.height;
    var startWave = start === null || start === void 0 ? void 0 : start[size];
    var endWave = end === null || end === void 0 ? void 0 : end[size];
    var heightWave = height === null || height === void 0 ? void 0 : height[size];
    // Fixed waves have a fixed height and are positioned underneath the content
    // (basically a background that does not get cut off).
    var isFixedWave = type.startsWith("fixed");
    if (isFixedWave) {
        return /*#__PURE__*/ _jsxs(FixedWave, {
            children: [
                /*#__PURE__*/ _jsxs(FixedWaveWaves, {
                    isFullWidth: fullWidth,
                    height: heightWave,
                    backgroundStyle: backgroundStyle,
                    "aria-hidden": "true",
                    children: [
                        startWave,
                        endWave && /*#__PURE__*/ _jsx(FixedWaveEnd, {
                            children: endWave
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(FixedWaveContent, {
                    children: children
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(ScalableWave, {
        isFullWidth: fullWidth,
        backgroundStyle: backgroundStyle,
        children: [
            startWave,
            children,
            endWave && /*#__PURE__*/ _jsx(ScalableWaveEnd, {
                isFullWidth: fullWidth,
                children: endWave
            })
        ]
    });
};
export { Wave };
